import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { scrollToId } from "@/lib/scroll";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Projects from "@/components/site/Projects";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";

export default function Home() {
  const { hash } = useLocation();
  useSeo({
    title: "ASSE DECOR Interiorismo | Interiorismo, reformas integrales y construcción",
    description: "Interiorismo, reformas integrales, cocinas, baños y construcción en San Sebastián de los Reyes (Madrid). Cuéntanos tu proyecto y solicita presupuesto.",
    path: "/",
  });

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Hero />
      <Marquee />
      <Services />
      <Projects />
      <About />
      <Process />
      <Contact />
    </>
  );
}
